import React from "react";
import { useRecordContext } from "react-admin";
import { styled } from "@mui/material/styles";

import Badge from "@mui/material/Badge";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import useSWR from "swr";
import groupBy from "lodash/groupBy";

import { withBusinessOnlyElseHide } from "../helpers/subscriptionPlan";
import { CANCELLED, SHIPPED } from "../components/Constant";
import { useProfile } from "../components/DataHooks/useProfile";

const Root = styled("div")(({ theme }) => ({
  "& > *": {
    margin: theme.spacing(1),
  },
}));

const RelatedOrders = () => {
  const record = useRecordContext();
  const { contact, _id } = record || {};
  const { profile } = useProfile();

  const shouldFetch = profile && contact?._id && _id && profile.page?._id;

  const { data: orders, error } = useSWR(
    profile && contact && contact._id
      ? `${process.env.REACT_APP_CMS_HOST}/orders?_sort=createdAt:DESC&_start=0&_limit=100&contact=${contact._id}&status_nin=${CANCELLED}&status_nin=${SHIPPED}&_id_nin=${_id}&page=${profile.page._id}`
      : null,
    { revalidateOnFocus: false }
  );

  if (!orders && !error) return null;
  if (error) return <p>Related orders error.</p>;

  const grouped = groupBy(orders, (order) => order.status);
  const orderKeys = Object.keys(grouped);

  return (
    <Root>
      {orderKeys.map((statusKey) => {
        const relatedOrders = grouped[statusKey];
        const statusLabel = statusKey.replace(/_/g, " ");
        const queryFilter = JSON.stringify({
          contact: contact._id,
          _id_ne: _id,
          page: profile.page._id,
          status: statusKey,
        });

        return (
          <Tooltip
            key={statusKey}
            title={`Customer has ${statusLabel} orders`}
            placement="top-start"
          >
            <Badge badgeContent={relatedOrders.length} color="secondary">
              <Chip
                size="small"
                label={statusLabel}
                variant="outlined"
                component="a"
                target="_blank"
                rel="noopener noreferrer"
                href={`/#/orders?filter=${encodeURIComponent(queryFilter)}`}
                clickable
              />
            </Badge>
          </Tooltip>
        );
      })}
    </Root>
  );
};

const withContactExist = (Component) => (props) => {
  const record = useRecordContext();
  return record?.contact?._id ? <Component {...props} /> : null;
};

export default withBusinessOnlyElseHide(withContactExist(RelatedOrders));
